

export enum PriorityEnum {
    ONE_STAR = 1,
    TWO_STAR = 2,
    THREE_STAR = 3,
    FOUR_STAR = 4,
    FIVE_STAR = 5,
}

export enum WhatsappPriorityEnum{
    one = '1',
    two = '2',
    three = '3',
    four = '4',
    five = '5'
}